// Dom is usually updated on next tick, 4ms standard timeout
var DOM_UPDATE_DELAY = 4;
export var waitForDomUpdate = function waitForDomUpdate() {
  return new Promise(function (resolve) {
    return setTimeout(resolve, DOM_UPDATE_DELAY);
  });
};